import { TEXT_SELECTORS } from "./Selectors";
import IToolConfig from "../types/IToolConfig";

export interface IFilters {
    [key: string]: IToolConfig
}

export const FILTERS: IFilters = {
    'dark-contrast': {
        styles: {
            'color': '#FFF',
            'fill': '#FFF',
            'background-color': '#000'
        },
        childrenSelector: TEXT_SELECTORS
    },
    'light-contrast': {
        styles: {
            'color': '#000',
            'fill': '#000',
            'background-color': '#FFF'
        },
        childrenSelector: TEXT_SELECTORS
    },
    'high-contrast': {
        styles: {
            'filter': 'contrast(125%)'
        }
    },
    'high-saturation': {
        styles: {
            'filter': 'saturate(200%)'
        }
    },
    'low-saturation': {
        styles: {
            'filter': 'saturate(50%)'
        }
    },
    'monochrome': {
        styles: {
            'filter': 'grayscale(100%)'
        }
    },

    /*
    Bug:
    filter: (#svg) does not work when its applied to <html> tag. Works fine if its applied to <body/> tag, but it will make fixed position elements wonky.
    'tritanopia': {
        styles: {
            'filter': 'url(#asw-tritanopia-filter)'
        },
        childrenSelector: ['body']
    },
    'deuteranopia': {
        styles: {
            'filter': 'url("#asw-deuteranopia-filter")'
        }
    },
    'protanopia': {
        styles: {
            'filter': 'url("#asw-protanopia-filter")'
        }
    },
    */
}

export const SVG_FILTERS = `
<svg xmlns="http://www.w3.org/2000/svg" style="display:none">
  <defs>
    <filter id="asw-protanopia-filter">
      <feColorMatrix type="matrix" values="0.567, 0.433, 0, 0, 0, 0.558, 0.442, 0, 0, 0, 0, 0.242, 0.758, 0, 0, 0, 0, 0, 1, 0" />
    </filter>
    <filter id="asw-deuteranopia-filter">
      <feColorMatrix type="matrix" values="0.625, 0.375, 0, 0, 0, 0.7, 0.3, 0, 0, 0, 0, 0.3, 0.7, 0, 0, 0, 0, 0, 1, 0" />
    </filter>
    <filter id="asw-tritanopia-filter">
      <feColorMatrix type="matrix" values="0.95, 0.05, 0, 0, 0, 0, 0.433, 0.567, 0, 0, 0, 0.475, 0.525, 0, 0, 0, 0, 0, 1, 0" />
    </filter>
  </defs>
</svg>

 <div id="filter-overlay"></div>
`;

export default FILTERS